module.exports = __webpack_public_path__ + "img/logo.0a0666b7.png";